"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbortManager = void 0;
var ManagedAbortable_1 = __importDefault(require("./ManagedAbortable"));
var AbortManager = /** @class */ (function () {
    function AbortManager() {
        this.abortables = new Map(null);
    }
    AbortManager.build = function () {
        return new AbortManager();
    };
    AbortManager.prototype.registerAbortable = function (abortable, controller, tags) {
        var _this = this;
        if (tags) {
            tags = Array.isArray(tags) ? tags : [tags];
        }
        else {
            tags = [];
        }
        var managedAbortable = new ManagedAbortable_1.default(abortable, controller, tags);
        this.addAbortable(managedAbortable);
        return abortable.finally(function () {
            _this.delete(managedAbortable);
        });
    };
    AbortManager.prototype.abort = function (tags) {
        var _this = this;
        tags = Array.isArray(tags) ? tags : [tags];
        tags.forEach(function (tag) {
            _this.abortOne(tag);
        });
    };
    AbortManager.prototype.createSetWithTag = function (tag) {
        if (!this.abortables.has(tag)) {
            this.abortables.set(tag, new Set());
        }
        return this.abortables.get(tag);
    };
    AbortManager.prototype.addAbortable = function (abortable) {
        var _this = this;
        abortable.tags.forEach(function (tag) {
            var tagsSet = _this.createSetWithTag(tag);
            tagsSet.add(abortable);
        });
    };
    AbortManager.prototype.abortOne = function (tag) {
        var abortables = this.abortables.get(tag);
        if (abortables) {
            abortables.forEach(function (managedAbortable) {
                managedAbortable.controller.abort();
            });
            this.abortables.delete(tag);
        }
    };
    AbortManager.prototype.delete = function (abortable) {
        var _this = this;
        abortable.tags.forEach(function (tag) {
            var abortables = _this.abortables.get(tag);
            abortables = new Set(__spreadArray([], __read(abortables), false).filter(function (el) { return el !== abortable; }));
            if (abortables.size > 0) {
                _this.abortables.set(tag, abortables);
            }
            else {
                _this.abortables.delete(tag);
            }
        });
    };
    return AbortManager;
}());
exports.AbortManager = AbortManager;
//# sourceMappingURL=AbortManager.js.map